/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
/* eslint max-len:0 */

import { toMessages } from 'config/messages';

export default toMessages('VccInterest', {
  Header: 'Virtual Credit Card Payments',
  Subheader: 'A fast, convenient and secure way to get paid.'
});